// extracted by mini-css-extract-plugin
export default {"wrapper":"TimeSlotItemComponent_wrapper__-WXZz","timeWrapper":"TimeSlotItemComponent_timeWrapper__8epwq"};